import type { SvgIconComponent } from '@mui/icons-material';

import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import Facebook from '@mui/icons-material/Facebook';
import ForumOutlined from '@mui/icons-material/ForumOutlined';
import MailOutlined from '@mui/icons-material/MailOutlined';
import MoreHorizOutlined from '@mui/icons-material/MoreHorizOutlined';
import TrendingUp from '@mui/icons-material/TrendingUp';

import { InquirySourceDto } from '@/api/generated';

export const inquirySourceLabels = {
  [InquirySourceDto.Active]: 'active',
  [InquirySourceDto.Facebook]: 'facebook',
  [InquirySourceDto.Form]: 'form',
  [InquirySourceDto.Mailbox]: 'mailbox',
  [InquirySourceDto.Other]: 'other',
  [InquirySourceDto.Reactive]: 'reactive',
} as const;

export type InquirySourceAppearance = {
  accent: string;
  Icon: SvgIconComponent;
};

export type InquirySourceKey = (typeof inquirySourceLabels)[InquirySourceDto];

export const inquirySourceAppearance: Record<InquirySourceKey, InquirySourceAppearance> = {
  active: { accent: '#8171a0', Icon: TrendingUp },
  facebook: { accent: '#4a71b4', Icon: Facebook },
  form: { accent: '#427b6b', Icon: DescriptionOutlined },
  mailbox: { accent: '#ab8249', Icon: MailOutlined },
  other: { accent: '#b46386', Icon: MoreHorizOutlined },
  reactive: { accent: '#578c91', Icon: ForumOutlined },
};
